import React from 'react';
import styled from '@emotion/styled';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints } = StyleLibrary;

const VerticalSplitContainer = styled.div<Props>(props => ({
  display: 'flex',
  flexDirection: 'column',

  '& > div': {
    display: 'flex',
    flexDirection: 'column',

    // z-index is 1 here to ensure the pattern from the Header Component appears infront of the backgorund but behind the content.
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
  },

  [mqBreakpoints.desktop]: {
    flexDirection: props.rowReverse ? 'row-reverse' : 'row',

    '& > div': {
      width: '50%',
    },
  },
}));

type Props = React.HTMLAttributes<HTMLDivElement> & {
  rowReverse?: boolean;
};

export const VerticalSplit: React.FC<Props> = props => {
  return <VerticalSplitContainer {...props}>{props.children}</VerticalSplitContainer>;
};
